import {AxiosInstance} from "axios";
import Brand from "../model/brand/Brand";
import {BrandJobTypeUtilityApiDto, BrandJobTypeUtilityUpdateApiDto} from "./model/rest";

/**
 * Api for brand.
 */
export default class BrandApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch brands.
	 * @returns {Promise<Brand[]>} Promise containing all brands.
	 */
	fetchBrands(): Promise<Brand[]> {
		const url = `/api/web/brands`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Brand.fromJson));
	}

    /**
     * Create brand action.
     */
    createBrand(data: Brand): Promise<Brand> {
        const url = `/api/web/brands`;
        return this.axiosInstance.post(url, data.toJson()).then(resp => Brand.fromJson(resp.data));
    }

    /**
	 * Set brand as default.
     */
	setBrandAsDefault(brandId: string): Promise<void> {
        const url = `/api/web/brands/${brandId}/default`;
		return this.axiosInstance.put(url).then(() => {});
    }

    /**
     * Update brand action.
     */
    updateBrand(brandId: string, data: Brand): Promise<Brand> {
        const url = `/api/web/brands/${brandId}`;
        return this.axiosInstance.put(url, data.toJson()).then(resp => Brand.fromJson(resp.data));
    }

    fetchJobTypeUtilities(brandId: string): Promise<BrandJobTypeUtilityApiDto[]> {
        const url = `/api/web/brands/${brandId}/job_types/utilities`;
        return this.axiosInstance.get(url).then(r => r.data);
    }

    updateJobTypeUtilities(brandId: string, updates: BrandJobTypeUtilityUpdateApiDto[]): Promise<BrandJobTypeUtilityApiDto[]> {
        const url = `/api/web/brands/${brandId}/job_types/utilities`;
        return this.axiosInstance.put(url, updates).then(r => r.data);
    }
}